import { ActionTypes as types, defaultCardSpec } from '../constants'
import serverProps from '../utils/serverProps'

function getInitialState(state = serverProps) {
  const { cardSpecs = {} } = state
  const initialState = {
    cardSpecs,
    cardSpec: defaultCardSpec, // the card spec based on the card number
    cardNumber: '',
    expiry: '',
    securityCode: '',
    addedCards: [],
    cardWasAdded: false,
  }
  return initialState
}

export default (state = getInitialState(), action) => {
  switch (action.type) {
    case types.EXTERNAL.RECEIVED_DATA:
      return {
        ...state,
        ...getInitialState(action.data),
      }

    case types.TRANSACTION.RECEIVED_SPECS:
      return {
        ...state,
        cardSpecs: action.data.cardSpecs,
      }

    case types.TRANSACTION.CHANGE_CARD_NUMBER:
      return {
        ...state,
        cardNumber: action.data.cardNumber,
        cardSpec: action.data.cardSpec,
      }

    case types.TRANSACTION.CHANGE_EXPIRY:
      return {
        ...state,
        expiry: action.data.expiry,
      }

    case types.TRANSACTION.CHANGE_SECURITY_CODE:
      return {
        ...state,
        securityCode: action.data.securityCode,
      }

    case types.TRANSACTION.CHANGE_CARD_TYPE:
      const cardTypes = state.cardSpecs.cardTypes
      const supportedCards = Object.keys(state.cardSpecs.cardTypes)
      const cardType = supportedCards.find(
        card => card === action.data.cardType
      )
      return {
        ...state,
        cardSpec: cardTypes[cardType],
      }

    case types.OVERPANELS.TOGGLE_ADD_CARD_OVERPANEL:
      return {
        ...state,
        cardSpec: defaultCardSpec,
      }

    case types.TRANSACTION.ADDED_CARD:
      return {
        ...state,
        cardSpec: defaultCardSpec,
        cardNumber: '',
        expiry: '',
        securityCode: '',
        addedCards: [action.data.addedCard, ...state.addedCards],
      }

    case types.TRANSACTION.SUCCESS_FB_ADD_CARD:
      return {
        ...state,
        cardWasAdded: true,
      }

    default:
      return state
  }
}
